export default {
    baseStyle: {
        container: {style: {alignItems: 'baseline'}},
        label: {
            width: 'full',
            fontFamily: 'DM Sans',
            fontWeight: '500'
        },
        control: {
            marginTop: '2px',
            borderColor: '#A0A0A0',
            _checked: {
                backgroundColor: 'primaryButtonColor',
                borderColor: 'primaryButtonColor',
                _hover: {
                    bg: 'buttonHoverColor',
                    borderColor: 'buttonHoverColor'
                }
            }
        }
    },
    sizes: {
        md: {
            label: {fontSize: 'sm'} //16px
        }
    }
}
